import { render, staticRenderFns } from "./ServiceJoinRead.vue?vue&type=template&id=6ec5eb52&scoped=true&"
import script from "./ServiceJoinRead.vue?vue&type=script&lang=js&"
export * from "./ServiceJoinRead.vue?vue&type=script&lang=js&"
import style0 from "./ServiceJoinRead.vue?vue&type=style&index=0&id=6ec5eb52&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec5eb52",
  null
  
)

export default component.exports